import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mahimtopunecabservice() {



  const cardData = {


  keyword: "Mahim to Pune Cab Service",

  headingDescription: "Trustline Cab provides reliable Mahim to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure timely pickups, smooth travel via the Mumbai-Pune Expressway, and a hassle-free journey from Mahim to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, clean and well-maintained vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Mahim to Pune taxi services.",

 topPlaces: [
  {
    title: "Hinjewadi",
    description: "Hinjewadi is Pune's major IT and business hub, home to Rajiv Gandhi Infotech Park, multinational companies, software firms, and corporate offices. It is one of the most popular destinations for travelers arriving in Pune."
  },
  {
    title: "Pune Airport",
    description: "Pune Airport is a major transportation hub connecting Pune with different cities. It is a common destination for business travelers, tourists, and passengers requiring airport transfers."
  },
  {
    title: "Kharadi",
    description: "Kharadi is a prominent IT and commercial area in Pune, known for EON IT Park, corporate offices, hotels, and modern business infrastructure."
  },
  {
    title: "Pimpri Chinchwad",
    description: "Pimpri Chinchwad is a major industrial and residential region near Pune, known for automobile companies, manufacturing industries, and commercial developments."
  },
  {
    title: "Baner",
    description: "Baner is a premium Pune locality featuring IT offices, business parks, restaurants, cafés, and modern residential projects."
  },
  {
    title: "Lavasa",
    description: "Lavasa is a scenic hill city near Pune known for lakeside views, beautiful landscapes, adventure activities, and peaceful surroundings."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a famous hill station near Pune popular for waterfalls, caves, viewpoints, and weekend getaways."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station near Pune known for strawberry farms, viewpoints, lakes, waterfalls, and pleasant weather."
  },
  {
    title: "Pawna Lake",
    description: "Pawna Lake is a popular weekend destination near Pune famous for camping, boating, mountain views, and nature experiences."
  },
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a historic Pune attraction known for trekking, scenic views, and Maratha history."
  }
],





"services": [
  {
    "name": "Mahim to Pune Cab",
    "description": "Book Mahim to Pune Cab for safe and comfortable intercity travel with professional chauffeurs, clean AC vehicles, fixed fares, doorstep pickup, luggage assistance, and reliable one way or round trip travel options."
  },
  {
    "name": "Mahim to Pune Cab Service",
    "description": "Choose Mahim to Pune Cab Service with Sedan, Ertiga, Innova, and SUV vehicles, experienced drivers, transparent pricing, online booking, and 24x7 customer support for hassle-free journeys."
  },
  {
    "name": "Mahim to Pune Taxi Service",
    "description": "Travel with Mahim to Pune Taxi Service offering affordable fares, comfortable AC cars, professional chauffeurs, flexible pickup timings, and smooth highway transportation."
  },
  {
    "name": "Mahim to Pune One Way Cab",
    "description": "Reserve Mahim to Pune One Way Cab for direct travel with fixed pricing, doorstep pickup, clean vehicles, experienced drivers, and convenient destination drop."
  },
  {
    "name": "Mahim to Pune Taxi Fare",
    "description": "Check Mahim to Pune Taxi Fare with transparent rates, affordable packages, multiple vehicle choices, and no hidden charges for reliable travel."
  },
  {
    "name": "Mahim to Pune Cab Booking",
    "description": "Complete Mahim to Pune Cab Booking online with instant confirmation, secure reservations, multiple cab options, and professional chauffeur-driven transportation."
  },
  {
    "name": "Cab from Mahim to Pune",
    "description": "Hire Cab from Mahim to Pune for comfortable long-distance journeys with AC cars, spacious luggage space, experienced drivers, and dependable service."
  },
  {
    "name": "Mahim to Pune Car Rental",
    "description": "Book Mahim to Pune Car Rental for private travel with Sedan, Ertiga, Innova Crysta, and premium vehicles available for one way, round trip, and outstation journeys."
  },
  {
    "name": "Mahim to Pune Taxi Booking Online",
    "description": "Reserve Mahim to Pune Taxi Booking Online with quick confirmation, flexible timings, transparent fares, and comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Cheap Cab Mahim to Pune",
    "description": "Choose Cheap Cab Mahim to Pune for budget-friendly travel with clean AC cars, professional drivers, affordable pricing, and reliable outstation services."
  },
  {
    "name": "Mahim to Pune Outstation Cab",
    "description": "Book Mahim to Pune Outstation Cab for safe intercity journeys with premium vehicles, experienced chauffeurs, fixed fares, and comfortable highway travel."
  },
  {
    "name": "Mahim to Pune AC Taxi Service",
    "description": "Travel comfortably with Mahim to Pune AC Taxi Service featuring air-conditioned vehicles, professional drivers, transparent pricing, and smooth travel experience."
  },
  {
    "name": "Mahim to Pune Innova Cab",
    "description": "Reserve Mahim to Pune Innova Cab for family trips, corporate travel, airport transfers, and group journeys with spacious seating and premium comfort."
  },
  {
    "name": "Mahim to Pune SUV Taxi",
    "description": "Book Mahim to Pune SUV Taxi for luxury and comfortable travel with spacious interiors, experienced chauffeurs, and reliable outstation transportation."
  },
  {
    "name": "Mahim to Pune Cab Price",
    "description": "Check Mahim to Pune Cab Price with affordable packages, transparent pricing, multiple vehicle options, and convenient booking facilities."
  },
  {
    "name": "Book Mahim to Pune Cab Online",
    "description": "Book Mahim to Pune Cab Online with instant confirmation, easy reservations, professional drivers, and comfortable AC vehicles for smooth travel."
  },
  {
    "name": "Mahim to Pune One Side Taxi",
    "description": "Choose Mahim to Pune One Side Taxi for affordable one way travel with fixed fares, doorstep pickup, and reliable chauffeur-driven service."
  },
  {
    "name": "Mahim to Pune Sedan Cab",
    "description": "Hire Mahim to Pune Sedan Cab for economical and comfortable travel with clean AC sedans, experienced chauffeurs, and smooth highway journeys."
  },
  {
    "name": "Mahim to Pune Ertiga Cab",
    "description": "Book Mahim to Pune Ertiga Cab for spacious six-seater travel, family trips, corporate journeys, and comfortable outstation transportation."
  },
  {
    "name": "Mahim to Pune Innova Crysta Cab",
    "description": "Reserve Mahim to Pune Innova Crysta Cab for premium travel with luxury seating, spacious luggage capacity, professional drivers, and comfortable long-distance rides."
  },
  {
    "name": "Mahim to Pune Taxi Charges",
    "description": "Check Mahim to Pune Taxi Charges with transparent pricing, affordable packages, vehicle choices, and reliable cab services."
  },
  {
    "name": "Mahim to Pune Private Cab",
    "description": "Choose Mahim to Pune Private Cab for exclusive chauffeur-driven travel with privacy, flexible pickup timings, and comfortable seating."
  },
  {
    "name": "Mahim to Pune Airport Cab",
    "description": "Book Mahim to Pune Airport Cab for punctual airport transfers with professional drivers, AC vehicles, luggage assistance, and reliable service."
  },
  {
    "name": "Best Cab Service Mahim to Pune",
    "description": "Choose Best Cab Service Mahim to Pune with premium vehicles, experienced chauffeurs, affordable fares, and dependable customer support."
  },
  {
    "name": "Mahim to Pune Outstation Taxi",
    "description": "Book Mahim to Pune Outstation Taxi for safe long-distance travel with clean vehicles, fixed rates, professional drivers, and comfortable journeys."
  }
],

"tableData": [
  ["Mahim to Pune Cab", "Mahim to Pune Cab Service"],
  ["Mahim to Pune Taxi Service", "Mahim to Pune One Way Cab"],
  ["Mahim to Pune Taxi Fare", "Mahim to Pune Cab Booking"],
  ["Cab from Mahim to Pune", "Mahim to Pune Car Rental"],
  ["Mahim to Pune Taxi Booking Online", "Cheap Cab Mahim to Pune"],
  ["Mahim to Pune Outstation Cab", "Mahim to Pune AC Taxi Service"],
  ["Mahim to Pune Innova Cab", "Mahim to Pune SUV Taxi"],
  ["Mahim to Pune Cab Price", "Book Mahim to Pune Cab Online"],
  ["Mahim to Pune One Side Taxi", "Mahim to Pune Sedan Cab"],
  ["Mahim to Pune Ertiga Cab", "Mahim to Pune Innova Crysta Cab"],
  ["Mahim to Pune Taxi Charges", "Mahim to Pune Private Cab"],
  ["Mahim to Pune Airport Cab", "Best Cab Service Mahim to Pune"],
  ["Mahim to Pune Outstation Taxi", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Mahim to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab provides dependable Mahim to Pune cab services with comfortable vehicles, experienced drivers, and smooth intercity travel solutions for passengers."
  },
  {
    WhyChooseheading: "Convenient Pickup from Mahim",
    WhyChoosedescription: "Enjoy doorstep pickup from Mahim West, Mahim East, Mahim Railway Station, hotels, offices, and residential areas with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Safe Mumbai Pune Expressway Journey",
    WhyChoosedescription: "Our professional chauffeurs ensure a secure and comfortable ride with proper route knowledge and timely travel management."
  },
  {
    WhyChooseheading: "Wide Range of Cab Options",
    WhyChoosedescription: "Select from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your group size, comfort, and luggage requirements."
  },
  {
    WhyChooseheading: "Transparent & Affordable Cab Fare",
    WhyChoosedescription: "Get clear fare details before booking with competitive pricing and no hidden charges for your Mahim to Pune journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Availability",
    WhyChoosedescription: "Book one-way cabs, return trips, airport transfers, or customized travel plans according to your schedule and destination."
  },
  {
    WhyChooseheading: "Suitable for Corporate & Family Travel",
    WhyChoosedescription: "Our Mahim to Pune cabs are ideal for business meetings, office travel, family trips, airport transfers, and personal journeys."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Support",
    WhyChoosedescription: "Book your Mahim to Pune cab anytime with quick confirmation and dedicated assistance for a comfortable travel experience."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Mahim to Pune Cab Service?",
    answer: "Yes, Trustline Cab offers reliable Mahim to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Mahim to Pune?",
    answer: "Yes, one-way cab services are available with doorstep pickup from Mahim and direct drop anywhere in Pune."
  },
  {
    question: "Do you provide pickup from Mahim Railway Station?",
    answer: "Yes, pickup is available from Mahim Railway Station, Mahim East, Mahim West, hotels, offices, and nearby Mumbai locations."
  },
  {
    question: "Which vehicles are available for Mahim to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable long-distance travel."
  },
  {
    question: "Is Mahim to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7 according to your preferred travel timing."
  },
  {
    question: "Can I book a return cab from Pune to Mahim?",
    answer: "Yes, round-trip cab services are available for passengers planning return travel between Pune and Mahim."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed booking quotation."
  },
  {
    question: "Should I book my Mahim to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and preferred pickup timing."
  },
  {
    question: "Do you provide Mahim to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are suitable for corporate meetings, employee transportation, client visits, and business travel."
  },
  {
    question: "How can I book Mahim to Pune Cab Service with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Arjun Mehta",
    feedback: "Trustline Travels provided excellent Mahim to Pune cab service. The driver was punctual, the vehicle was clean, and the complete journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback: "The booking process was quick and the service was professional. The cab was spacious, the driver was polite, and our travel from Mahim to Pune was completely hassle-free.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mahim to Pune Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/mahim-to-pune-cab-service.webp",
  "description":
    "Book Mahim to Pune Cab Service with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Mahim to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport transfers, business trips, and outstation travel.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/mahim-to-pune-cab-service"
  }
};






  return (
    <div>
<Helmet>
  <title>Mahim to Pune Cab Service | One Way Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Mahim to Pune Cab Service with Trustline Travels for reliable one-way and round-trip taxi services. Get affordable cabs from Mahim to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta for outstation travel, airport transfers, and corporate trips available 24x7."
  />

  <meta
    name="keywords"
    content="Mahim to Pune Cab, Mahim to Pune Cab Service, Mahim to Pune Taxi Service, Mahim to Pune One Way Cab, Mahim to Pune Taxi Fare, Mahim to Pune Cab Booking, Cab from Mahim to Pune, Mahim to Pune Car Rental, Mahim to Pune Taxi Booking Online, Cheap Cab Mahim to Pune, Mahim to Pune Outstation Cab, Mahim to Pune Cab Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mahimtopunecabservice;